import React from "react";

const Search = () => {

    return <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9988 9.67333H10.3038L10.0574 9.43595C11.1132 8.20486 11.6588 6.52531 11.3596 4.74023C10.9461 2.29565 8.90475 0.343496 6.44114 0.0445176C2.71932 -0.412743 -0.412985 2.71773 0.0445436 6.43737C0.343697 8.89955 2.29699 10.9396 4.74301 11.353C6.52912 11.6519 8.20966 11.1067 9.44147 10.0515L9.67903 10.2977V10.9924L13.4184 14.7296C13.7792 15.0901 14.3687 15.0901 14.7294 14.7296C15.0902 14.3691 15.0902 13.78 14.7294 13.4194L10.9988 9.67333ZM5.71965 9.67333C3.5288 9.67333 1.76028 7.90588 1.76028 5.71631C1.76028 3.52673 3.5288 1.75925 5.71965 1.75925C7.91051 1.75925 9.67903 3.52673 9.67903 5.71631C9.67903 7.90588 7.91051 9.67333 5.71965 9.67333Z" fill="currentColor"/>
    </svg>

}

export default Search;
